<template>
  <div class="antialiased">
    <Sidebar />
    <div class="page">
      <Header hint="Ketik no. invoice" />
      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Service Level</h2>
              </div>
            </div>
          </div>

          <div>
            <b-nav tabs>
              <b-nav-item active>
                <router-link to="../distribution-plan/service-level">
                  Daftar Service Level
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link to="../distribution-plan">
                  Daftar Invoice Pending
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link to="../distribution-plan/jadwal">
                  Daftar Jadwal Pengiriman
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link to="../distribution-plan/planed-driver">
                  Daftar Planed Drivers
                </router-link>
              </b-nav-item>
            </b-nav>
          </div>

          <div style="margin-top: 20px">
            <b-container class="bv-example-row mb-4">
              <b-row>
                <b-col cols="1">Data</b-col>
                <b-col cols="3">
                  <div class="form-group">
                    <selectize
                      id="type"
                      v-model="dataFilters.type"
                      data-placeholder="Value"
                    >
                      <option value="value">Value</option>
                      <option value="invoice">Invoice Number</option>
                    </selectize>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="1">Gudang</b-col>
                <b-col>
                  <input
                    type="text"
                    class="form-control mb-2"
                    placeholder="Search Gudang"
                    v-model="search_gudang"
                  />
                  <div
                    style="
                      position: relative;
                      overflow-y: auto;
                      max-height: 95px;
                    "
                  >
                    <b-button
                      v-for="(gudang, index) in filterGudang"
                      :key="index"
                      @click="_setGudang(gudang.id)"
                      size="sm"
                      variant="outline-primary mx-1 my-1"
                      :class="{
                        active: dataFilters.ids_gudang.includes(gudang.id),
                      }"
                    >
                      {{ gudang.nama_gudang }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-container>
            <Skeleton
              type="table"
              :length="14"
              class="mt-4 bg-white"
              v-if="loading"
            />
            <Nodata v-if="!loading && data.length === 0" />
            <div class="box" v-if="!loading && data.length > 0">
              <div class="card">
                <div class="table-responsive">
                  <table
                    class="table table-vcenter table-hover card-table table-striped"
                  >
                    <thead>
                      <tr style="text-align: center">
                        <th>Date</th>
                        <th>Total</th>
                        <th>
                          <div class="strong">Order</div>
                          Waiting
                        </th>
                        <th>
                          <div class="strong">Processing</div>
                          <div class="text-muted">Approved</div>
                        </th>
                        <th>Loaded</th>
                        <th>
                          <div class="strong">Delivered</div>
                          H+0
                        </th>
                        <th>
                          <div>H+1</div>
                        </th>
                        <th>
                          <div>H+2</div>
                        </th>
                        <th>Other</th>
                        <th>Service Level</th>
                        <th>
                          <div>Not Delivered</div>
                          Cancel / Closeds
                        </th>
                        <th>Finished</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(penjualan, index) in data"
                        style="border: none; text-align: center"
                        :key="index"
                      >
                        <td style="text-align: start">
                          {{ penjualan.tanggal_order }}
                        </td>
                        <td>{{ ribuan(penjualan.total_order.toFixed(0)) }}</td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.waiting,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.approved,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.loaded,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.delivered.h0,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.delivered.h1,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.delivered.h2,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.delivered.others,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          <b-button
                            size="sm"
                            :variant="
                              statusServiceLevel(
                                _setPercent(
                                  penjualan.delivered.h0 +
                                    penjualan.delivered.h1 +
                                    penjualan.delivered.h2,
                                  penjualan.total_order
                                )
                              )
                            "
                          >
                            {{
                              _setPercent(
                                penjualan.delivered.h0 +
                                  penjualan.delivered.h1 +
                                  penjualan.delivered.h2,
                                penjualan.total_order
                              )
                            }}%
                          </b-button>
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.cancled + penjualan.closed,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                        <td>
                          {{
                            _setPercent(
                              penjualan.delivered.h0 +
                                penjualan.delivered.h1 +
                                penjualan.delivered.h2 +
                                penjualan.delivered.others,
                              penjualan.total_order
                            )
                          }}%
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "DistributionPlanData",
  data() {
    return {
      animate: null,
      reload: 0,
      loading: true,
      gudangs: [],
      result: [],

      data: [],
      dataReport: [],
      dataFilters: {
        type: "invoice",
        ids_gudang: [],
      },

      search_gudang: null,
    };
  },
  mixins: [helper],
  computed: {
    filterGudang() {
      if (this.search_gudang) {
        console.log(this.search_gudang.toLowerCase().split(" "));
        return this.gudangs.filter((gudang) => {
          return this.search_gudang
            .toLowerCase()
            .split(" ")
            .every((v) => gudang.nama_gudang.toLowerCase().includes(v));
        });
      } else {
        return this.gudangs;
      }
    },
  },
  methods: {
    // Set color service level by condition percent
    statusServiceLevel(service_level) {
      console.log(service_level);
      let baik, netral, buruk;
      baik = "success";
      netral = "warning";
      buruk = "danger";
      if (this.dataFilters.type == "value") {
        if (service_level >= 95) {
          return baik;
        } else if (service_level >= 90 && service_level <= 95) {
          return netral;
        } else {
          return buruk;
        }
      } else {
        if (service_level >= 85) {
          return baik;
        } else if (service_level >= 75 && service_level <= 85) {
          return netral;
        } else {
          return buruk;
        }
      }
    },
    async _getGudang() {
      try {
        var res = await this.axios.get("gudang");
        this.gudangs = res.data.data;
        this.loadingFilter = false;
      } catch (error) {
        console.error(error);
      }
    },
    async _get() {
      this.loading = true;
      this.dataReport = [];
      try {
        var res = await this.axios.get("distribusi_report/service_level", {
          params: this.dataFilters,
        });
        this.data = res.data.data;
        this.loading = false;
        console.log(this.data);
      } catch (error) {
        this.loading = false;
      }
    },
    _setGudang(id_depo) {
      if (this.dataFilters.ids_gudang.includes(id_depo)) {
        var index = this.dataFilters.ids_gudang.indexOf(id_depo);
        this.dataFilters.ids_gudang.splice(index, 1);
      } else {
        this.dataFilters.ids_gudang.push(id_depo);
      }
      this._get();
    },
    _setPercent(total, total_order) {
      return ((total / total_order) * 100).toFixed(0);
    },
  },
  watch: {
    "dataFilters.type": function (val) {
      this._get();
    },
  },
  mounted() {
    this._getGudang();
    this._get();
  },
};
</script>
<style scoped>
.strong {
  font-weight: bold;
}

.btn-position {
  position: fixed;
  right: 15px;
  bottom: 15px;
}

.navbar-text {
  padding-top: 0.5rem !important;
}

.nav-item {
  width: 20%;
}
</style>
